export default (
  state = {
    addedCatalogIds: {}, // Holds the ID's of products added to dealtable
    columnDefs: [], // Holds the dealtable column data
    customColumnDefs: [], // Holds the dealtable custom column data (Columns added by end user)
    discount: {}, // Holds deal level and group level discount of the dealtable
    metaData: {}, // Holds readonly data needed for the ag-grid to work
    priceBook: {}, // Holds priceBook details associated to the dealtable
    productCatalogs: [], // Holds product data list
    props: {}, // Holds the droupdown values needed either in dealtable or forms in the page
    rowData: {}, // Holds the row information of the dealtable
    columnWidth: {}, // Holds the deal table column width
  },
  action,
) => {
  switch (action.type) {
    /**
     * Call this method when the document component is mounted.
     */
    case "REACTION_ON_DOCUMENT_PAGE_LOAD": {
      const payload = action.payload.dealTablePayload;
      if (payload.dealTableId) {
        return Object.assign({}, state, {
          addedCatalogIds: {
            ...state.addedCatalogIds,
            [payload.dealTableId]: payload.addedCatalogIds,
          },
          columnDefs: {
            ...state.columnDefs,
            [payload.dealTableId]: payload.columnDefs,
          },
          customColumnDefs: payload.customColumnDefs,
          discount: {
            ...state.discount,
            [payload.dealTableId]: payload.discount,
          },
          metaData: payload.metaData,
          priceBook: {
            ...state.priceBook,
            [payload.dealTableId]: payload.priceBook,
          },
          props: payload.props,
          rowData: {
            ...state.rowData,
            [payload.dealTableId]: payload.rowData,
          },
        });
      }
      return Object.assign({}, state, {
        columnDefs: payload.columnDefs,
        customColumnDefs: payload.customColumnDefs,
        metaData: payload.metaData,
        props: payload.props,
      });
    }

    /**
     * Call this method when the dealtable component is mounted.
     */
    case "REACTION_ON_PAGE_LOAD_IN_DEALTABLE": {
      return Object.assign({}, state, {
        addedCatalogIds: {
          ...state.addedCatalogIds,
          [action.payload.dealTableId]: action.payload.addedCatalogIds,
        },
        columnDefs: {
          ...state.columnDefs,
          [action.payload.dealTableId]: action.payload.columnDefs,
        },
        customColumnDefs: action.payload.customColumnDefs,
        discount: {
          ...state.discount,
          [action.payload.dealTableId]: action.payload.discount,
        },
        metaData: action.payload.metaData,
        props: action.payload.props,
        rowData: {
          ...state.rowData,
          [action.payload.dealTableId]: action.payload.rowData,
        },
      });
    }

    /**
     * Call this method when the dealtable is added from the document.
     */
    case "REACTION_ON_ADDING_DEALTABLE_TO_DOCUMENT": {
      return Object.assign({}, state, {
        addedCatalogIds: {
          ...state.addedCatalogIds,
          [action.payload.dealTableId]: action.payload.addedCatalogIds,
        },
        columnDefs: {
          ...state.columnDefs,
          [action.payload.dealTableId]: action.payload.columnDefs,
        },
        discount: {
          ...state.discount,
          [action.payload.dealTableId]: action.payload.discount,
        },
        metaData: action.payload.metaData,
        priceBook: {
          ...state.priceBook,
          [action.payload.dealTableId]: action.payload.priceBook,
        },
        props: action.payload.props,
        rowData: {
          ...state.rowData,
          [action.payload.dealTableId]: action.payload.rowData,
        },
      });
    }

    /**
     * Call this method when only row data is fetched from API.
     */
    case "UPDATE_DEALTABLE_ROWS": {
      return Object.assign({}, state, {
        addedCatalogIds: {
          ...state.addedCatalogIds,
          [action.payload.dealTableId]: action.payload.addedCatalogIds,
        },
        discount: {
          ...state.discount,
          [action.payload.dealTableId]: action.payload.discount,
        },
        rowData: {
          ...state.rowData,
          [action.payload.dealTableId]: action.payload.rowData,
        },
      });
    }

    /**
     * Call this method when adding a new row into the dealtable.
     */
    case "REACTION_ON_ADDING_ROWS_INTO_DEALTABLE": {
      return Object.assign({}, state, {
        addedCatalogIds: {
          ...state.addedCatalogIds,
          [action.payload.dealTableId]: action.payload.addedCatalogIds,
        },
        discount: {
          ...state.discount,
          [action.payload.dealTableId]: action.payload.discount,
        },
        productCatalogs: action.payload.productCatalogs,
        rowData: {
          ...state.rowData,
          [action.payload.dealTableId]: action.payload.rowData,
        },
      });
    }

    /**
     * Call this method when a cell value is changed in a row (or) when user
     * applies rounding concept to netamount value.
     */
    case "REACTION_ON_CELLVALUE_CHANGE_IN_DEALTABLE":
    case "REACTION_ON_ROUNDING_NETAMOUNT_IN_DEALTABLE": {
      return Object.assign({}, state, {
        discount: {
          ...state.discount,
          [action.payload.dealTableId]: action.payload.discount,
        },
        rowData: {
          ...state.rowData,
          [action.payload.dealTableId]: action.payload.rowData,
        },
      });
    }

    /**
     * Call this method when a row is deleted from dealtable.
     */
    case "REACTION_ON_ROW_DELETE_IN_DEALTABLE": {
      return Object.assign({}, state, {
        addedCatalogIds: {
          ...state.addedCatalogIds,
          [action.payload.dealTableId]: action.payload.addedCatalogIds,
        },
        // discount: {
        //   ...state.discount,
        //   [action.payload.dealTableId]: action.payload.discount,
        // },
        productCatalogs: action.payload.productCatalogs,
        rowData: {
          ...state.rowData,
          [action.payload.dealTableId]: action.payload.rowData,
        },
      });
    }

    case "REACTION_ON_ROW_UPDATE_IN_DEALTABLE_WITH_GROUP_ID": {
      return Object.assign({}, state, {
        rowData: {
          ...state.rowData,
          [action.payload.dealTableId]: action.payload.rowData,
        },
      });
    }

    /**
     * Call this method when a group is removed from dealtable.
     */
    case "REACTION_ON_ALL_GROUPS_DELETE_IN_DEALTABLE": {
      return Object.assign({}, state, {
        discount: {
          ...state.discount,
          [action.payload.dealTableId]: action.payload.discount,
        },
        rowData: {
          ...state.rowData,
          [action.payload.dealTableId]: action.payload.rowData,
        },
      });
    }

    /**
     * Call this method when a group OR deal level discount is applied in dealtable.
     */
    case "REACTION_ON_DISCOUNT_UPDATE_IN_DEALTABLE": {
      return Object.assign({}, state, {
        discount: {
          ...state.discount,
          [action.payload.dealTableId]: action.payload.discount,
        },
      });
    }

    /**
     * Call this method when a row is saved in dealtable.
     */
    case "REACTION_ON_DEALTABLE_SAVE": {
      return Object.assign({}, state, {
        discount: {
          ...state.discount,
          [action.payload.dealTableId]: action.payload.discount,
        },
        rowData: {
          ...state.rowData,
          [action.payload.dealTableId]: action.payload.rowData,
        },
      });
    }

    /**
     * Call this method when a product is searched in product catalog view.
     */
    case "UPDATE_PRODUCT_CATALOG_LIST": {
      return Object.assign({}, state, { productCatalogs: action.payload });
    }

    /**
     * Call this method when apply sorting for row
     */
    case "REACTION_AFTER_ROW_SORTING_IN_DEALTABLE": {
      return Object.assign({}, state, {
        rowData: {
          ...state.rowData,
          [action.payload.dealTableId]: action.payload.rowData,
        },
        columnDefs: {
          ...state.columnDefs,
          [action.payload.dealTableId]: action.payload.columnDefs,
        },
      });
    }

    /**
     * Call this method when a pricebook is replaced in dealtable
     */
    case "REACTION_ON_CHANGING_PRICEBOOK_IN_DEALTABLE": {
      return Object.assign({}, state, {
        addedCatalogIds: {
          ...state.addedCatalogIds,
          [action.payload.dealTableId]: [],
        },
        discount: {
          ...state.discount,
          [action.payload.dealTableId]: action.payload.discount,
        },
        priceBook: {
          ...state.priceBook,
          [action.payload.dealTableId]: action.payload.priceBook,
        },
        rowData: {
          ...state.rowData,
          [action.payload.dealTableId]: [],
        },
      });
    }

    /**
     * Call this method when a navigate between quotations.
     */
    case "NUKE_QUOTATION_DATA": {
      return Object.assign({}, state, {
        columnDefs: {},
        addedCatalogIds: {},
        discount: {},
        rowData: {},
      });
    }
    case "NUKE_QUOTETABLE_DATA": {
      return Object.assign({}, state, {
        columnDefs: {},
        addedCatalogIds: {},
        discount: {},
        rowData: {},
      });
    }
    case "APPLY_DEAL_TABLE_COLUM_WIDTH": {
      return Object.assign({}, state, {
        columnWidth: {
          ...state.columnWidth,
          [action.payload.dealTableId]: action.payload.changedColumns,
        },
      });
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/DealTableReducer.js